'use strict';

var React = require('react');

var SvgGlobeEuIcon = function SvgGlobeEuIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 10a7 7 0 1 1 14 0 7 7 0 0 1-14 0Zm7-5.5a5.5 5.5 0 0 0-3.391 9.83l.641-.641a2.918 2.918 0 0 1 3.61-.411.88.88 0 0 0 .625.118l3.259-.611a5.474 5.474 0 0 0 .702-3.56l-.018.006a.26.26 0 0 0-.178.248v.771a2 2 0 0 1-2 2c-.76 0-1.375-.616-1.375-1.375v-.375a.25.25 0 0 0-.25-.25h-.507a1.06 1.06 0 0 0-.947.585l-.123.246a2.115 2.115 0 0 1-3.978-.598l-.059-.353a2.537 2.537 0 0 1 1.7-2.824l.75-.25a.422.422 0 0 0 .289-.4c0-.757.443-1.443 1.132-1.753l.8-.361a5.557 5.557 0 0 0-.682-.042Zm2.769.747-2.27 1.023a.422.422 0 0 0-.249.385c0 .827-.53 1.562-1.314 1.824l-.75.25c-.484.161-.779.65-.695 1.154l.059.353a.615.615 0 0 0 1.157.174l.122-.245a2.559 2.559 0 0 1 2.29-1.415h.506c.966 0 1.75.784 1.75 1.75v.234a.5.5 0 0 0 .375-.484v-.771a1.76 1.76 0 0 1 1.204-1.67l.08-.028a5.522 5.522 0 0 0-2.265-2.534Zm-2.769 10.253c-.723 0-1.414-.14-2.046-.393l.357-.357a1.418 1.418 0 0 1 1.754-.2c.505.316 1.11.43 1.697.32l1.178-.22a5.48 5.48 0 0 1-2.94.85Z"
  }));
};
SvgGlobeEuIcon.displayName = "GlobeEuIcon";

exports.SvgGlobeEuIcon = SvgGlobeEuIcon;
